(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoTratamentoSementesCtrl', HistoricoTratamentoSementesController);

  HistoricoTratamentoSementesController.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    'PeriodSelectService',
    'HistoricosService',
    'MessagesService',
    '$routeParams',
    'TratamentoSementeService',
    '$q',
    '$route',
    'RecomendacoesSemeaduraService',
    'AtividadesService',
    'ItensService',
    'AplicacoesService'
  ];

  /* eslint-disable max-lines-per-function, max-params */
  function HistoricoTratamentoSementesController($scope, $rootScope, LoadingService, PeriodSelectService,
    HistoricosService, MessagesService, $routeParams, TratamentoSementeService, $q, $route,
    RecomendacoesSemeaduraService, AtividadesService, ItensService, AplicacoesService) {
    let hasPage = true;
    let inProgress = true;
    let requestId = 0;

    //////////////////////////////////////////
    // Controller data
    $scope.initialized = false;
    $scope.applications = [];
    $scope.tsFilters = {};
    $scope.filtroPeriodo = {};
    $scope.loadingCultivares = true;
    $scope.loadingAplicacoes = false;
    $scope.statusFilter = { integrado: false, erro: false, pendente: false };

    //////////////////////////////////////////
    // Bindable methods
    $scope.resetPeriodsFilter = resetPeriodsFilter;
    $scope.getApplications = getApplications;
    $scope.getSubCardApplicationId = getSubCardApplicationId;
    $scope.getCardApplicationId = getCardApplicationId;
    $scope.openRecommendationDetail = openRecommendationDetail;
    $scope.isOpened = isOpened;
    $scope.canManage = canManage;
    $scope.setFilterAttribute = setFilterAttribute;
    $scope.openPeriodsFilter = openPeriodsFilter;
    $scope.setPeriodo = setPeriodo;
    $scope.toggleStatusFilter = toggleStatusFilter;
    $scope.getStatusFilterLabel = getStatusFilterLabel;
    $scope.getRecommendationProducts = getRecommendationProducts;
    $scope.getQuantidadeTotal = getQuantidadeTotal;
    $scope.getUnidade = getUnidade;

    function initializeVariables() {
      $scope.tsFilters.page = 1;
      hasPage = true;
      inProgress = false;
      requestId += 1;
      $scope.applications = [];
    }

    function initialize() {
      if (!$scope.initialized) {
        $scope.initialized = true;
        $scope.loadingAplicacoes = true;

        initializeVariables();
        resetPeriodsFilter();
        $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
        setValoresComBaseNoHistorico();

        listCultivares();

        getApplications();
        AplicacoesService.closeOpenRecommendationsModal(closeRecommendations);
      }
    }

    function listCultivares() {
      ItensService.listCultivares({ possui_tratamento: false }).then(function(data) {
        $scope.cultivares = data.data || [];
      })
        .finally(function() {
          $scope.loadingCultivares = false;
        });
    }

    function setValoresComBaseNoHistorico() {
      let filteredPeriod;

      if ($routeParams.date || $routeParams.historyDate) {
        filteredPeriod = HistoricosService.getFilteredPeriod(
          { data: $routeParams.date || $routeParams.historyDate },
          $scope.safras
        );
      }

      if ($routeParams.date || $routeParams.historyDate) {
        $scope.tsFilters.dataInicial = moment(filteredPeriod.dataInicial);
        $scope.tsFilters.dataFinal = moment(filteredPeriod.dataFinal);
        $scope.period = filteredPeriod.periodo;
      }
    }

    function resetPeriodsFilter() {
      $scope.tsFilters.dataInicial = null;
      $scope.tsFilters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    }

    function getApplications() {
      const hasFilterPage = $scope.tsFilters && $scope.tsFilters.page;

      if (hasFilterPage && hasPage && !inProgress) {
        $scope.loadingAplicacoes = true;
        inProgress = true;
        const currentRequestId = requestId;

        const promises = [
          TratamentoSementeService.list(getParamsFromFilters())
        ];

        $q.all(promises)
          .then((data) => {
            if (currentRequestId === requestId) {
              processApplicationsResult(data);
            }
          })
          .catch(() => {
            if (currentRequestId === requestId) {
              getApplicationsError();
            }
          })
          .finally(function() {
            if (currentRequestId === requestId) {
              inProgress = false;
              $scope.loadingAplicacoes = false;
            }
          });
      }
    }

    function getParamsFromFilters() {
      return {
        data_inicial: $scope.tsFilters.dataInicial && $scope.tsFilters.dataInicial.format(MOMENT_DATE_ENGLISH_FORMAT),
        data_final: $scope.tsFilters.dataFinal && $scope.tsFilters.dataFinal.format(MOMENT_DATE_ENGLISH_FORMAT),
        epoca: $scope.tsFilters.epoca && $scope.tsFilters.epoca.codigo,
        item_estoque_origem: $scope.tsFilters.cultivar && $scope.tsFilters.cultivar.item_id,
        status: $scope.tsFilters.status
      };
    }

    /* eslint-disable complexity */
    function processApplicationsResult(data) {
      const dados = data[0].data || [];
      hasPage = (((data[0].pages || {}).pagination || {}).next || 0) > $scope.tsFilters.page;

      if (dados.length > 0) {
        $scope.tsFilters.page++;
        $scope.applications = $scope.applications.concat(
          dados.map((ts) => {
            ts.allData = ts;
            return ts;
          })
        );

        if ($scope.applications.length === 1) {
          openApplicationDetail($scope.applications[0]);
        } else if ($routeParams.activeApplication) {
          const app = $scope.applications.find(function(a) {
            return +a.id === +$routeParams.activeApplication;
          });
          if (app) {
            openApplicationDetail(app);
          } else {
            updateRouteParams();
          }
        }
      }
    }

    function openApplicationDetail(ts) {
      if (!ts || !ts.id) {
        return;
      }

      ts.openRecommendation = false;

      if (!ts.open) {
        ts.open = true;
        updateRouteParams(ts.id);
      } else {
        ts.open = false;
        updateRouteParams();
      }
    }

    function updateRouteParams(id = null) {
      if (!$scope.map) {
        $route.updateParams({
          activeApplication: id
        });
      }
    }

    function getApplicationsError() {
      MessagesService.alert('Não foi possível buscar a lista de tratamentos de semente.');
    }

    function setFilterAttribute(attribute, object, event) {
      preventDefault(event);
      initializeVariables();
      $scope.tsFilters[attribute] = object;
      getApplications();
    }

    function openPeriodsFilter(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.tsFilters).then(function() {
        $scope.setPeriodo();
      });
    }

    function toggleStatusFilter(status, event) {
      stopPropagation(event);
      preventDefault(event);
      $scope.statusFilter[status] = !$scope.statusFilter[status];
      initializeVariables();
      $scope.tsFilters.status = buildStatusParam($scope.statusFilter);
      getApplications();
    }

    function getStatusFilterLabel() {
      const statusLabels = { integrado: 'Integrado', erro: 'Erro', pendente: 'Pendente' };
      const chaves = Object.keys(statusLabels);
      const selecionadas = chaves.filter((chave) => $scope.statusFilter[chave]);

      if (selecionadas.length === 0 || selecionadas.length === chaves.length) {
        return 'Status';
      }
      return selecionadas.map((chave) => statusLabels[chave]).join(', ');
    }

    function buildStatusParam(statusFilter) {
      const statusParaApi = { integrado: 'finalizado', erro: 'erro', pendente: 'pendente' };
      const selecionadas = Object.keys(statusParaApi).filter((chave) => statusFilter[chave]);
      return selecionadas.length ? selecionadas.map((chave) => statusParaApi[chave]).join(',') : null;
    }

    function setPeriodo(periodo, event) {
      preventDefault(event);
      initializeVariables();
      if (periodo) {
        $scope.tsFilters.dataInicial = periodo.dataInicial;
        $scope.tsFilters.dataFinal = periodo.dataFinal;
        $scope.period.periodo = periodo.descricao;
      }
      getApplications();
    }

    function getSubCardApplicationId(adubacao) {
      return `subcard-adubacao-${adubacao.id}`;
    }

    function getCardApplicationId(adubacao) {
      return `adubacao-${adubacao.id}`;
    }

    function setPositionSubCardTS(adubacao) {
      const card = $(`#${$scope.getCardApplicationId(adubacao)}`);
      const subCard = $(`#${$scope.getSubCardApplicationId(adubacao)}`);

      subCard.css({
        'min-height': `${card.height()}px`,
        width: `${card.width()}px`,
        top: `${card.offset().top}px`
      });
    }

    function canManage() {
      return $rootScope.permissions.plantio.canManage;
    }

    function openRecommendationDetail(ts) {
      if (!ts || !ts.id || !ts.open) {
        return;
      }

      if (!ts.openRecommendation) {
        ts.openRecommendation = !ts.openRecommendation;
        ts.recommendation = {};
        setPositionSubCardTS(ts);

        if (ts.recomendacao_id) {
          ts.loadingRecommendation = true;
          RecomendacoesSemeaduraService.get(ts.recomendacao_id)
            .then((response) => processDataRecommendation(response, ts))
            .catch((e) => {
              MessagesService.alert('Não foi possível consultar a recomendação.');
              console.error('Erro ao consultar recomendação', e);
              ts.loadingRecommendation = false;
            });
        }
      } else {
        ts.openRecommendation = !ts.openRecommendation;
      }
    }

    function processDataRecommendation(data, ts) {
      if (data.data) {
        const recommendation = data.data;
        const hasInoTransferencia = _.find(recommendation.tratamentos, (t) => t.ino_transferencia_atributo_ids.size);

        if (hasInoTransferencia) {
          recommendation.tratamentos = _.filter(
            recommendation.tratamentos,
            (t) => _.includes(t.ino_transferencia_atributo_id, ts.atributo_id)
          );
        }

        ts.recommendation = recommendation;
        setAplicadoRecomendado(ts);
        finishLoadingRecommendation(ts);
      } else {
        ts.recommendation = {};
        finishLoadingRecommendation(ts);
      }
    }

    function getTsPercentage(quantityApplied, productRecommendation, productApplied) {
      if (!productApplied || !productRecommendation) {
        return 0;
      }

      const doseRecommendation = AplicacoesService.getDoseNormalized(productRecommendation);
      const doseApplied = AplicacoesService.getDoseNormalized(productApplied) / quantityApplied * 100;

      if (!doseRecommendation || !doseApplied) {
        return 0;
      }
      return doseApplied / doseRecommendation * 100;
    }

    function setAplicadoRecomendado(tratamento) {
      if (!tratamento.recommendation) {
        return;
      }
      tratamento.insumosRecomendacao = tratamento.recommendation.tratamentos
        .concat(tratamento.recommendation.cultivares).map(function(produto) {
          const produtoAplicado = tratamento.itens.filter(function(item) {
            return item.item_estoque.item_id === produto.insumo_id;
          })[0] || {};
          produtoAplicado.dose = produtoAplicado.quantidade;
          return {
            produto: !produtoAplicado.item_codigo,
            aplicado: getTsPercentage(tratamento.quantidade, produto, produtoAplicado)
          };
        });
    }

    function finishLoadingRecommendation(ts) {
      ts.loadingRecommendation = false;
    }

    function isOpened(ts) {
      return ts.open && ts.openRecommendation;
    }

    function getRecommendationProducts(ts) {
      const products = ((ts.recommendation || {}).tratamentos || []);
      return _.uniqBy(products, 'insumo_id');
    }

    function getQuantidadeTotal(ts, produto) {
      const result = produto.dose * ts.quantidade;
      if (!AtividadesService.isCorn(ts.recommendation.atividade.descricao)) {
        return result / 100;
      }
      return result;
    }

    function getUnidade(ts) {
      if (AtividadesService.isCorn(ts.recommendation.atividade.descricao)) {
        return ts.item_estoque_origem.unidade.abreviatura;
      }
      return '100kg';
    }

    function closeRecommendations() {
      ($scope.applications || []).forEach(function(application) {
        application.openRecommendation = false;
      });
      $scope.$apply();
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$on('tsActivate', initialize);

    $scope.$on('$routeUpdate', function() {
      if ($scope.tsFilters) {
        const { gleba, dataInicial } = $scope.tsFilters;
        const { activeGleba, historyDate } = $routeParams;

        const filterGlebaChanged = activeGleba && +activeGleba !== (gleba || {}).id;
        const filterDateChanged = historyDate && historyDate !== dataInicial;

        if (filterGlebaChanged || filterDateChanged) {
          initializeVariables();
          setValoresComBaseNoHistorico();
          $scope.getApplications();
        }
      }
    });
  }
}());
